import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValgPaginatorComponent } from "@valg-shared/components/table/table/valg-paginator/valg-paginator.component";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { TranslateModule } from "@ngx-translate/core";
import { MatIconModule } from "@angular/material/icon";
import { ValgInputModule } from '@valg-shared/components/input/input.module';


@NgModule({
  declarations: [ ValgPaginatorComponent ],
  exports: [ ValgPaginatorComponent ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatMenuModule,
        TranslateModule,
        MatIconModule,
        ValgInputModule,
    ]
})
export class ValgPaginatorModule { }

